function NotFound() {
    return (  
        <h2>Not found page - 404</h2>
    );
}

export default NotFound;